
import { Create, TextInput, BooleanInput, NumberInput, SelectInput, Edit, Toolbar, required, Form, TransformData, FormDataConsumer, } from "react-admin";
import { ImageInputSafe } from "@/src/components";
import { Card, CardContent, Grid, Stack } from "@mui/material";
import { emptify } from "@/src/utils";
import { TargetEditSection, PricingInput, StoreRefsInput } from "./Sections";


const CreditProductContent = () =>
    <Card>
        <CardContent>
            <Stack>
                <Grid container spacing={{ xs: 0, md: 2 }}>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <TextInput source="title" validate={required()} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <TextInput source="description" />
                    </Grid>
                </Grid>

                <Grid container spacing={{ xs: 0, md: 2 }}>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <NumberInput source="count" validate={required()} />
                        <Stack direction={"row"} spacing={2}>
                            <BooleanInput source="recommended" />
                            <BooleanInput source="active" />
                        </Stack>
                        <NumberInput source="displayOrder" defaultValue={0} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <ImageInputSafe source="imageUrl"
                            accept={{ 'image/*': ['.jpeg', '.jpg', '.png', '.svg'], }}
                            multiple={false} />
                    </Grid>
                </Grid>
                <Card>
                    <CardContent>
                        <BooleanInput source="storeProduct" helperText={false} sx={{ flexShrink: 0 }} />
                        <FormDataConsumer>{({ formData }) =>
                            <>
                                {!formData.storeProduct && <TargetEditSection />}
                                {formData.storeProduct && <StoreRefsInput source="storeRefs" />}
                                {!formData.storeProduct && <PricingInput source="pricing" />}
                            </>}
                        </FormDataConsumer>

                    </CardContent>
                </Card>

            </Stack>
        </CardContent>
        <Toolbar />
    </Card>




const transform: TransformData = (data: any) => {
    data.pricing?.forEach((prc: any) => {
        emptify(prc);
    });
    if (data.storeRefs) {
        data.storeRefs = data.storeRefs.filter(
            (ref: { store?: string; sku?: string }) => ref?.store && ref?.sku
        );
    }
    // emptify(data, "target")

    return data;
}

export const CreditProductCreate = () => {

    return (
        <Create transform={transform}>
            <Form sanitizeEmptyValues>
                <CreditProductContent />
            </Form>
        </Create>
    );

}


export const CreditProductEdit = () => {

    return (
        <Edit transform={transform}>
            <Form sanitizeEmptyValues>
                <CreditProductContent />
            </Form>
        </Edit>
    );

}

